import React from "react";
// import sectiondata from "../../data/sections.json";
// import parse from "html-react-parser";
import { Link, useHistory } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";

import { useSelector, useDispatch } from "react-redux";
import {
  loginUserThunk,
  selectLoading,
  selectError,
  selectSuccess,
} from "../../features/auth/authSlice";
import { CircularProgress, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const loadingLogin = useSelector(selectLoading);
  const errorLogin = useSelector(selectError);
  const successLogin = useSelector(selectSuccess);

  // let publicUrl = process.env.PUBLIC_URL + "/";
  // let imagealt = "image";
  // let data = sectiondata.whychooseus;

  return (
    <div className="register-page-area pd-bottom-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-4 col-lg-5 col-md-6 mb-5 mb-md-0">
            <Formik
              initialValues={initialValues}
              initialErrors={initialValues}
              validationSchema={loginSchema}
              onSubmit={(values, { setSubmitting }) => {
                dispatch(loginUserThunk(values));
              }}
            >
              {({
                isValid,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form className="contact-form-wrap contact-form-bg">
                  <h4>Login</h4>
                  <div className="rld-single-input">
                    <input
                      placeholder="Entry Login"
                      name="email"
                      type="email"
                      value={values.email}
                      errors={errors}
                      touched={touched}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="rld-single-input">
                    <input
                      type="password"
                      placeholder="Entry Password"
                      name="password"
                      value={values.password}
                      type="password"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="btn-wrap">
                    {loadingLogin ? (
                      <CircularProgress
                        className="mt-4"
                        style={{ color: "#fda94f" }}
                      />
                    ) : (
                      <button
                        disabled={!isValid}
                        onClick={(e) => {
                          e.preventDefault();
                          handleSubmit();
                        }}
                        className="btn btn-yellow"
                      >
                        Sign In
                      </button>
                    )}
                  </div>
                  <p className="mt-3">
                    Not signed up yet? &nbsp;
                    <Link to="/registration">Create an account</Link>
                  </p>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      <Snackbar open={errorLogin} autoHideDuration={1000}>
        <Alert severity="error">Incorrect Email or Password</Alert>
      </Snackbar>
      <Snackbar open={successLogin} autoHideDuration={1000}>
        <Alert severity="success">Successfully logged in</Alert>
      </Snackbar>
    </div>
  );
}

export default Login;

export const LoadingComponent = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "30px" }}>
      <CircularProgress />
    </div>
  );
};

const initialValues = {
  email: "",
  password: "",
};
const loginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string().required("Required"),
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
